"use client"

import React from 'react'
import { phoneData } from './Data/PhoneData'
import { useMobileContext } from './MobileContext'
import { Card, Typography, Tag, Divider, Space } from 'antd'
import { useTranslation } from 'react-i18next'

const { Title, Text } = Typography

const Phones: React.FC = () => {
  const isMobile = useMobileContext()
  const { t } = useTranslation()
  
  return (
    <Card className={!isMobile ? 'p-6' : 'p-2'}>
      <Title level={2}>{t("esim.device_support_content_title")}</Title>
      
      <Text className="block mb-4">
        {t("esim.device_support_content_desc")}
      </Text>
      
      <div className="phone-list mt-6">
        {phoneData.map((brand, brandIdx) => (
          <div key={brandIdx} className="phone-list__brand">
            <Title level={3} className="phone-list__brand-name">{t(brand.brand)}</Title>
            
            <div className="phone-list__brand-models">
              {brand.models.map((model, modelIdx) => (
                <Tag key={modelIdx} color="blue">{t(model)}</Tag>
              ))}
            </div>
            
            {brand.notes.length > 0 && (
              <div className="phone-list__brand-notes mt-2">
                <Space orientation="vertical" size={8}>
                  {brand.notes.map((note, noteIdx) => (
                    <Text key={noteIdx} type="secondary">* {t(note)}</Text>
                  ))}
                </Space>
              </div>
            )}
            
            {brandIdx < phoneData.length - 1 && <Divider />}
          </div>
        ))}
      </div>
      
      <div className="mt-6">
        <Text type="secondary">
          {t("esim.device_support_content_note")}
        </Text>
      </div>
    </Card>
  )
}

export default Phones